/* PROJECT PAGE */
Vue.component('projectpage',{
    template:'#projectpage-template',
    data:function() {
        return {
            Autolinker: Autolinker,
            project:[],
            ticket:[],
            dropZoneInstance:'',
            dropZoneFiles:[],
            user_activities:[],
            worktime_hours: '',
            worktime_minutes: '',
            posting_in_action: false,
            feed:[],
            files:[],
            active_tab:'project_page',
            file_filter: '',
            file_filter_type: {
                project_brief: true,
                ticket_brief: true,
                comment_file: true
            },
            current_user_id: -1,
            user_is_moderator: false,
            user_is_account_manager:false,
            brief_fields: [],
            project_closing_is_active:false,
            closing_monthly_project: {
                id: null,
                tickets: []
            }
        };
    },
    created:function(){
        activeInstance = this;
        setTimeout(function(){
            var token = $("meta[name='csrf-token']").attr('content');
            activeInstance.loadProjectDetails();
            activeInstance.loadProjectFeed();
            activeInstance.loadFiles();
            //SET CURRENT USER ID BASED ON HIDDEN INPUT IN TEMPLATE
            activeInstance.current_user_id = $("#current_user_id").val();
            activeInstance.user_is_moderator = $('#user_is_moderator').val();
            activeInstance.user_is_account_manager = $('#user_is_account_manager').val();
        },200);
    },
    events: {
    },
    methods:{
        undoTicketClose:function(ticket){
            axios.post(baseURL+'/admin/ticket/undoTicketClose')
        },
        sendMonthlyProjectCloseData: function (project, invoice_required) {
            var closing_tickets = [];

            $.each(project.tickets, function (index, ticket) {
                if (ticket.closing) {
                    closing_tickets.push(ticket.id);
                    ticket.phase = 'completed';
                }
            });

            $('body').LoadingOverlay("show");
            axios.post(baseURL + '/admin/monthly_project/close', {
                'project_id': activeInstance.project.id,
                'tickets': closing_tickets,
                'invoice_required': invoice_required
            })
                .then(function (response) {
                    $('body').LoadingOverlay("hide");
                    /*
                    $.each(activeInstance.projects_client_approved,function(index,project){
                        if (record.id == project.id) {
                            project.phase = 'completed';
                        }
                    });
                    */
                    vex.dialog.alert('A ' + project.name + ' projekt és ticketei lezárásra kerültek.');
                    activeInstance.project_closing_is_active = false;

                    setTimeout(function() {
                        location.href = baseURL+'/admin/projects';
                    },3000);
                })
                .catch(function (error, response) {
                    $('body').LoadingOverlay("hide");
                    console.log(error.response.data);

                    //IF WE GOT UNCLOSED TICKETS -> BRING IN THE TICKET MOVING DIALOG
                    if (error.response.data.status == 'unclosed_tickets_present') {
                        vex.dialog.open({
                            input: [
                                /* TITLE */
                                '<h2 style="margin-top:10px;margin-bottom:30px;">' + project.name + '</h2>',
                                '<h4 style="margin-top:10px;margin-bottom:30px;">Fennmaradó ticketek átmozgatása új projektbe</h4>',
                                '<div style="margin-bottom:20px;color:#3aaad8;font-weight:bold;font-size:14px;font-style:italic;">Kérjük add meg az új projekt adatait, amibe a fennmaradó (zárásra nem kijelölt) ticketek kerülnek.</div>',
                                '' + activeInstance.generateTicketMigrationList(),
                                /* PROJECT NAME */
                                '<label style="margin-top:10px;">Az új projekt neve</label>',
                                '<input style="width:100%;display:block;" name="name" type="text" value="' + project.name + ' (másolat)" placeholder="Az új projekt neve" required />',

                                /* DEADLINE */
                                '<fieldset style="margin-top:20px;margin-bottom: 0px;" class="form-group no_padding">',
                                '<label>Ügyfél leadás határideje</label>',
                                '<div class=\'input-group date\' id=\'datetimepicker6\'>',
                                '<input required name="deadline" type=\'text\' class="form-control-vex disabled" id="deadline" />',
                                '<span class="input-group-addon">',
                                '<span class="glyphicon glyphicon-calendar"></span>',
                                '</span>',
                                '</div>',
                                '</fieldset>',

                                /* DATE OF COMPLETION */
                                '<label style="margin-top:20px;">Teljesítés hónapja</label>',
                                '<select name="completion_month" style="margin-bottom:30px;" id="completion_month" required  class="form-control-vex">',
                                '<option value="01">Január</option>',
                                '<option value="02">Február</option>',
                                '<option value="03">Március</option>',
                                '<option value="04">Április</option>',
                                '<option value="05">Május</option>',
                                '<option value="06">Június</option>',
                                '<option value="07">Július</option>',
                                '<option value="08">Augusztus</option>',
                                '<option value="09">Szeptember</option>',
                                '<option value="10">Október</option>',
                                '<option value="11">November</option>',
                                '<option value="12">December</option>',
                                '</select>',
                                ' '
                            ].join(''),
                            buttons: [
                                $.extend({}, vex.dialog.buttons.YES, {text: 'Rendben'}),
                                $.extend({}, vex.dialog.buttons.NO, {text: 'Mégse'})
                            ],
                            afterOpen: function () {
                                setTimeout(function () {
                                    $('#datetimepicker6').datetimepicker({
                                        format: 'YYYY-MM-DD HH:00',
                                        locale: 'hu'
                                    });
                                }, 300);

                            },
                            callback: function (data) {
                                if (!data) {
                                    console.log('Cancelled')
                                }
                                else {
                                    axios.post(baseURL + '/api/project/clone', {
                                        'old_project_id': project.id,
                                        'name': data.name,
                                        'deadline': data.deadline,
                                        'completion_month': data.completion_month
                                    })
                                        .then(function (response) {

                                            //CLOSE TICKETS AND THEN THE PROJECT
                                            activeInstance.sendMonthlyProjectCloseData(project, project.outgoing_invoice_number);
                                            //FETCH THE DATA

                                            activeInstance.getPendingClosures();
                                            activeInstance.getAcceptedClosures();
                                            successNotification('A ' + project.name + ' projekt lezárásra került.');
                                        });
                                }
                            }
                        });
                    }
                    else {
                        activeInstance.sendMonthlyProjectCloseData(project, project.outgoing_invoice_number);
                        activeInstance.getPendingClosures();
                        activeInstance.getAcceptedClosures();
                        successNotification('A ' + project.name + ' projekt lezárásra került.');
                    }


                });


        },
        acceptMonthlyProjectClose: function (project) {

            console.log(project);
            var got_unclosed_tickets = false;
            $.each(project.tickets, function (ticket) {
                if (ticket.phase != 'completed') {

                }
            });

            bootbox.confirm({
                message: "Igényel számlázást a projekt?",
                buttons: {
                    confirm: {
                        label: 'Igen',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Nem',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    activeInstance.sendMonthlyProjectCloseData(project, result);
                    project.invoice_required= result;
                }
            });

        },
        processTicketClose: function(ticket) {
            $('body').LoadingOverlay("show");
            axios.post(baseURL + '/admin/project/ticket/close', {
                'ticket_id': ticket.id,
                'invoice_required':ticket.invoice_required
            })
            //ON SUCCESS
            .then(function (response) {
                $('body').LoadingOverlay("hide");
                if (response.data == "OK") {
                    ticket.phase = "client_approved";
                }
            })
            //ON ERROR
            .catch(function (error, response) {
                $('body').LoadingOverlay("hide");
                bootbox.alert("Váratlan hiba történt a ticket zárása közben.");
            });
        },
        undoTicketClosure: function(ticket) {
            bootbox.confirm('Biztosan visszavonod a(z) ' + ticket.name + ' ticketet a pénzügyi zárás alól?', function (value) {
                if (value == true) {
                    $('body').LoadingOverlay("show");
                    if (activeInstance.project.billing_type == "project_based") {
                        axios.post(baseURL+'/admin/project/ticket/undo_project_manager_closure',{
                           'ticket_id':ticket.id
                        })
                            .then(function(error){

                                activeInstance.loadProjectDetails();
                                $('body').LoadingOverlay("hide");
                            })
                            .catch(function(error){

                            });
                    } else {

                    }
                }
            });
        },
        closeTicket: function(ticket) {
            bootbox.confirm('Biztosan lezárod a(z) ' + ticket.name + ' ticketet?', function (value) {
                if (value == true) {

                    if (activeInstance.project.billing_type == "project_based") {
                        bootbox.confirm({
                            message: "Igényel számlázást a ticket?",
                            buttons: {
                                confirm: {
                                    label: 'Igen',
                                    className: 'btn-success'
                                },
                                cancel: {
                                    label: 'Nem',
                                    className: 'btn-danger'
                                }
                            },
                            callback: function (result) {
                                ticket.invoice_required = result;
                                activeInstance.processTicketClose(ticket);
                            }
                        });
                    } else {
                        activeInstance.project_closing_is_active=true;
                    }
                }
            });
        },
        closeProject: function (record) {

            console.log(record);

            switch (record.billing_type) {

                //####################################
                //##PROJECT BASED#####################
                //####################################
                case 'project_based':
                    bootbox.confirm('Biztosan lezárod a(z) ' + record.name + ' projektet?', function (value) {
                        if (value == true) {
                            bootbox.confirm({
                                message: "Igényel számlázást a projekt?",
                                buttons: {
                                    confirm: {
                                        label: 'Igen',
                                        className: 'btn-success'
                                    },
                                    cancel: {
                                        label: 'Nem',
                                        className: 'btn-danger'
                                    }
                                },
                                callback: function (result) {

                                        showLoadingOverlay();
                                        axios.post(baseURL + '/admin/project/close', {
                                            'project_id': record.id,
                                            'invoice_required':result
                                        })
                                        //ON SUCCESS
                                        .then(function (response) {
                                            $('body').LoadingOverlay("hide");

                                            vex.dialog.alert('A ' + record.name + ' projekt zárása továbbításra került a pénzügy felé.');
                                            activeInstance.project_closing_is_active = false;

                                            setTimeout(function() {
                                                location.href = baseURL+'/admin/projects';
                                            },3000);
                                        })

                                        //ON ERROR
                                        .catch(function (error, response) {
                                            $('body').LoadingOverlay("hide");

                                            if (error.response.data.status == 'unclosed_tickets_present') {
                                                bootbox.alert("A projektet még nem lehet lezárni, mert nyitott ticketet tartalmaz.");
                                            } else {
                                                console.log(error);
                                            }
                                        });
                                    }
                            });
                        }
                    });

                    break;

                //####################################
                //##MONTHLY FEE ######################
                //####################################
                case 'monthly_fee':

                    activeInstance.project_closing_is_active = true;

                    var contains_active_ticket = false;

                    $.each(record.tickets, function (index, ticket) {
                        if (ticket.phase != 'completed') {
                            contains_active_ticket = true;
                            return false;
                        }
                    });

                    if (!contains_active_ticket) {
                        bootbox.confirm('Biztosan lezárod a(z) ' + record.name + ' projektet?', function (value) {
                            if (value == true) {
                                activeInstance.acceptMonthlyProjectClose(record);
                            } else {
                                activeInstance.project_closing_is_active = false;
                            }
                        });
                    }

                    break;
            }
        },
        undoProjectClosure: function(project) {
            bootbox.confirm('Biztosan visszavonod a(z) ' + project.name + ' projektet a pénzügyi zárás alól?', function (value) {
                if (value == true) {
                    $('body').LoadingOverlay("show");

                        axios.post(baseURL+'/admin/project/undo_project_manager_closure',{
                            'project_id':project.id
                        })
                        .then(function(error){

                            activeInstance.loadProjectDetails();
                            $('body').LoadingOverlay("hide");
                        })
                        .catch(function(error){

                        });

                }
            });
        },
        generateTicketMigrationList: function () {
            var full_text = '<ul class="closure_list">';
            $.each(activeInstance.project.tickets, function (index, ticket) {
                if (ticket.phase != 'completed') {
                    full_text += '<li>' + ticket.name + '</li>';
                }
            });
            full_text += '</ul>';
            return full_text;
        },
        resetClosingMonthlyProject: function () {
            activeInstance.closing_monthly_project = {
                id: null,
                tickets: []
            }
        },

        removeAccents:function(string){
            return RemoveAccents(string);
        },
        humanDate:function($date){
            return moment($date).fromNow();
        },
        filterFiles: function(arr) {
            var new_arr = JSON.parse(JSON.stringify(arr)),
                that = this;

            new_arr = new_arr.filter(function(item) {
                return that.file_filter_type[item.type];
            });

            if (that.file_filter) {
                new_arr = new_arr.filter(function(item) {
                    return item.filename.toLowerCase().indexOf(that.file_filter.toLowerCase()) != -1;
                });
            }

            return new_arr;
        },
        toggleFilterType: function(values, state = null) {

            console.log(this.file_filter_type);

            if (!Array.isArray(values)) {
                values = [values];
            }

            for(var i = 0, i_l = values.length; i < i_l; i ++) {
                this.file_filter_type[values[i]] = (state == null) ? !this.file_filter_type[values[i]] : state;
            }
        },
        loadFiles:function(){
            var project_id = $('#project_id').val();

            showLoadingOverlay();
            Vue.http.get(baseURL + '/api/project/'+project_id+'/files',function(response){
                $('body').LoadingOverlay("hide");
                activeInstance.files = response;
            });
        },
        goToTicketPage:function(project_id,ticket_id){
            location.href=baseURL+'/admin/project/'+project_id+'/ticket/'+ticket_id
        },
        loadProjectDetails:function(){
            var project_id = $('#project_id').val();

            showLoadingOverlay();
            Vue.http.get(baseURL + '/api/project/list/one/'+project_id,function(response){

                console.log('project_data_response:');
                console.log(response);

                response.start = response.start.substring(0,10);
                response.deadline = response.deadline.substring(0,10);
                activeInstance.project = response;
                document.title = activeInstance.project.name+' - ODIN Enterprise Manager';
                $("#page_title").text(activeInstance.project.brand.name.toUpperCase()+' / '+activeInstance.project.name.toUpperCase());


                // GET PROJECT BRIEFS
                axios.get(baseURL+'/api/project/'+project_id+'/brief/get'
                ).then(function (resp) {
                    $('body').LoadingOverlay("hide");
                    activeInstance.brief_fields = resp.data;
                }).catch(function (error) {
                    $('body').LoadingOverlay("hide");
                    console.log(error);
                });

            });
        },
        loadProjectFeed:function(){
            var project_id = $('#project_id').val();
            showLoadingOverlay();
            Vue.http.get(baseURL + '/api/project/'+project_id+'/feed',function(response){
                $('body').LoadingOverlay("hide");
                activeInstance.feed = response;
            });
        },
        //DELETE A FILE ATTACHMENT
        deleteFileAttachment:function(file){
            showLoadingOverlay();
            axios.post(baseURL+'/admin/project/brief/remove_uploaded_file_id', {
                file_record_id: file.file_record_id
            }).then(function (response) {
                $('body').LoadingOverlay("hide");
                activeInstance.dropZoneFiles.$remove(file);
            })
                .catch(function (error) {
                    $('body').LoadingOverlay("hide");
                    console.log(error);
                });
        },
        getTicketData:function(){

            var ticket_id = $('#ticket_id').val();

            showLoadingOverlay();
            Vue.http.get(baseURL+'/api/ticket/'+ticket_id).then(function(response){

                $('body').LoadingOverlay("hide");
                activeInstance.ticket = response.data;

                setTimeout(function(){
                    activeInstance.loadProjectDetails();
                },300);

            }).bind(this);
        },
        getUserActivities:function(){
            showLoadingOverlay();
            Vue.http.get(baseURL+'/api/user/activities').then(function(response){
                $('body').LoadingOverlay("hide");
                activeInstance.user_activities = response.data;
            }).bind(this);
        },
        postComment:function(){

            activeInstance.posting_in_action = true;

            //GET THE MESSAGE
            var message = $('#new_comment_editor').trumbowyg('html');

            if(message.length<2) {
                errorNotification('A bejegyzés tartalma túl rövid.');
                activeInstance.posting_in_action = false;
                return false;
            }

            if(activeInstance.worktime_hours=='-1') {
                errorNotification('Az óra mező kitöltése szükséges.');
                activeInstance.posting_in_action = false;
                $('#field_minute').addClass('error');
                return false;
            }

            if(activeInstance.worktime_minutes=='-1') {
                errorNotification('A perc mező kitöltése szükséges.');
                activeInstance.posting_in_action = false;
                $('#field_hour').addClass('error');
                return false;
            }

            if(activeInstance.activity_id == null) {
                errorNotification('A tevékenység mező kitöltése szükséges.');
                alert('e');
                $('#field_activity').addClass('error');
                activeInstance.posting_in_action = false;
                return false;
            }

            //GET THE FILES
            var files = jQuery.extend(true, {}, activeInstance.dropZoneFiles);

            $.each(files,function(index,file){
                delete file.file;
            });

            showLoadingOverlay();
            axios.post(baseURL+'/api/post/comment', {
                'message':message,
                'ticket_id':activeInstance.ticket.id,
                'project_id':activeInstance.ticket.project_id,
                'activity_id':activeInstance.activity_id,
                'worktime_hours':activeInstance.worktime_hours,
                'worktime_minutes':activeInstance.worktime_minutes,
                'files':files
            })
                .then(function (response) {
                    $('body').LoadingOverlay("hide");
                    console.log(response);
                    activeInstance.getTicketData();
                    $('#new_comment_editor').trumbowyg('html', "");
                    activeInstance.dropZoneFiles = [];
                    activeInstance.posting_in_action = false;
                    activeInstance.worktime_hours = -1;
                    activeInstance.worktime_minutes = -1;
                    activeInstance.activity_id = 0;
                })
                .catch(function (error) {
                    $('body').LoadingOverlay("hide");
                    console.log(error);
                    activeInstance.posting_in_action = false;
                });
        },
        downloadWholeProject:function(url){

            $('body').LoadingOverlay("show");
            location.href=url;
            setTimeout(function(){
                $('body').LoadingOverlay("hide");
            },3000);

        },
    },
    computed:{
        projectIsClosable:function(){
            var closable = true;
            if(activeInstance.project.billing_type=='project_based'){
                $.each(activeInstance.project.tickets,function(index, ticket){
                    if(ticket.phase != 'completed' && ticket.phase !='client_approved'){
                        closable = false;
                    }
                });
            }
            else{
                if(activeInstance.project.billing_type=='monthly_fee'){
                    closable = true;
                }
            }

            return closable;

        }

    }
});